<template>
<div>
    <div class="form-container ou-donation-form">
        <div class="holder">
            <PaymentForm class="form-horizontal">
                <FormSection title="Payment Amount">
                 <FormRow> 
              <div>
              <AmountSelectorList />
              <ErrorLabel field="amount" />
            </div>
                    </FormRow>
                </FormSection>                 
                <FormSection title="Personal Information">
                    <FormRow inline>      
                        <FormCol field="title" :flex="1" />
                        <FormCol field="firstName" :flex="2" />
                        <FormCol field="lastName" :flex="2" />
                    </FormRow>
                    <FormRow inline>
                        <FormCol field="email" />
                        <FormCol field="phone" />
                    </FormRow>                                       
                    <DonorAddress />
                </FormSection>              
                <FormSection title="Payment Information" last>
 <div class="frequency">
              <PaymentOptions addSplit :splitMonths="8" :minimumAmt="500"/>
            </div>                  
                    <FormRow inline>
                    <FormCol field="card" :showLabel="false"/>
                    </FormRow>
                </FormSection>
                <PaymentButton showAmount btnText="Pay"/>
            </PaymentForm>
        </div>
    </div>
</div>
</template>


<script lang="ts">
import { defineComponent } from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'

export default defineComponent({
  setup() {
    const { setValue, form } = usePaymentForm()

    return {
      form,
      setValue
    }
  },
})
</script>
<style scoped lang="scss">
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}

h3{
    text-align: center;
    margin-top: 10px;
    font-size: 23px;
    margin-bottom: 0px;
    padding-bottom: 13px;
}

::v-deep .oudonate-other-amount.USD {
  .amount_other__wrapper::before {
    padding: 11px 8px;
    border-right: 1px solid #ddd;
    height: auto;
}
}
::v-deep .form-container.ou-donation-form {
    margin: 4px 0px;
    padding: 0px;
    box-shadow: none;

    .amount_other__wrapper.USD {
    width: 100%;
    min-width: 100% !important;
    max-width: 100% !important;
}
}




</style>

